export const railStyles = {
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
  width: '260px',
};

export const railTitleStyles = ({ palette }) => ({
  color: palette.text.secondary,
  textTransform: 'uppercase',
  marginBottom: '12px',
  paddingLeft: '4px',
});

export const parallelGroupStyles = ({ palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '10px',
  padding: '8px 8px 0',
  borderRadius: '12px',
  border: `1px dashed ${palette.border.input}`,
});

export const parallelCaptionStyles = ({ palette }) => ({
  color: palette.text.secondary,
  textTransform: 'uppercase',
  marginBottom: '8px',
  paddingLeft: '4px',
});
